"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
var _instrumentActions = require("../../redux/actions/instrumentActions");
var _productActions = require("../../redux/actions/productActions");
var _level2Actions = require("../../redux/actions/level2Actions");
var _DigitalAssetsPage = _interopRequireDefault(require("./DigitalAssetsPage"));
var _get = _interopRequireDefault(require("lodash/get"));
var _digitalAssetsSelectors = require("../../redux/selectors/digitalAssetsSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    instruments: (0, _instrumentPositionSelectors.instrumentsWithProductFullNamesAndProductSymbols)(state),
    selectedInstrument: state.apexCore.instrument.selectedInstrumentId,
    products: (0, _get["default"])(state, 'apexCore.product.products', []),
    productAttributes: (0, _get["default"])(state, 'productAttributes', {}),
    digitalAssets: (0, _digitalAssetsSelectors.digitalAssetsListSelector)(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, getState) {
  return {
    getProductAttributes: function getProductAttributes(payload) {
      return dispatch((0, _productActions.getProductAttributes)(payload));
    },
    selectInstrument: function selectInstrument(payload) {
      return dispatch((0, _instrumentActions.selectInstrument)(parseInt(payload, 10)));
    },
    unsubscribeLevel2: function unsubscribeLevel2(instrumentId) {
      return dispatch((0, _level2Actions.unsubscribeLevel2)(instrumentId));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_DigitalAssetsPage["default"]);